// @flow

export { getCustomThemeLogo } from './get-custom-theme-logo';
